import { afterNextRender, Component } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { ToastCustomComponent } from './shared/widgets/toast/toast.component';
import { SpinnerComponent } from './shared/widgets/spinner/spinner.component';
import { NgxSpinnerModule } from 'ngx-spinner';
// import { AngularQueryDevtools } from '@tanstack/angular-query-devtools-experimental';
import { environment } from '../environments/environment';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: true,
  imports: [
    RouterModule,
    ToastCustomComponent,
    SpinnerComponent,
    NgxSpinnerModule,
    // AngularQueryDevtools,
    CommonModule,
  ],
})
export class AppComponent {
  title = 'Standard Organization of Nigeria';
  isProduction = environment.production;

  constructor(private router: Router) {
    afterNextRender(() => {
      this.router.events.subscribe((event) => {
        if (
          event instanceof NavigationEnd &&
          document.querySelector('nz-content')
        ) {
          document.querySelector('nz-content').scrollTop = 0;
        }
      });
    });
  }

  ngOnInit(): void {
    // Start all routes scroll position from top of page
  }
}
